import { Container, Stack } from "@mui/material";
import DolphinBanner from "./components/DolphinBanner";
import TabsHomeView from "./components/TabsHomeView";
import { AppTabContextProvider } from "./components/context";

const newTheme = {
  backgroundColor: "#0B2544",
  text: {
    color: {
      primary: "#00FFCB",
    },
  },
};

const Welcome = () => {
  return (
    <Stack width="100%" height="100%" bgcolor={newTheme.backgroundColor} sx={{ overflowX: "hidden" }}>
      <AppTabContextProvider>
        <Container maxWidth="xl">
          <Stack flexDirection="row" justifyContent={"end"} alignItems="center" p={2}>
            <Stack sx={{ display: { xs: "none", sm: "block" } }}>
              <img src="/static/images/AVC_WelcomeLogo.png" alt="logo-avc" width={50} height={50} />
            </Stack>
          </Stack>
          <DolphinBanner newTheme={newTheme} />
          <TabsHomeView id="product-tracking" newTheme={newTheme} />
        </Container>
      </AppTabContextProvider>
    </Stack>
  );
};
export default Welcome;
